"use strict";

var _classCallCheck = require("C:\\Users\\James\\Documents\\Dev\\vet-nurse-guide\\node_modules\\@babel\\runtime/helpers/classCallCheck");

module.exports = function LinkStyleImpl() {
  _classCallCheck(this, LinkStyleImpl);
};